// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module--container--2sNM9","slide":"styles-module--slide--3fcoB","slideImage":"styles-module--slideImage---K_-D","slideText":"styles-module--slideText--2QAtb"};